const submitSurvey = (data) => {
	return new Promise((resolve, reject) => {
		$.post(
			'/promotion/channel/submit',
			data,
			(data, textStatus, xhr) => {
				return resolve()
			},
			'json'
		)
	})
}

export default submitSurvey
